"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedErrorSpecs = exports.RateLimitedErrorDataSchema = exports.UnsupportedLocaleErrorDataSchema = exports.FeatureDisabledErrorDataSchema = exports.SuspendedErrorDataSchema = exports.InternalErrorDataSchema = exports.NotFoundErrorDataSchema = exports.BadRequestErrorDataSchema = exports.ForbiddenErrorDataSchema = exports.UnauthorizedErrorDataSchema = void 0;
exports.errorUnauthorized = errorUnauthorized;
exports.errorForbidden = errorForbidden;
exports.errorBadRequest = errorBadRequest;
exports.errorNotFound = errorNotFound;
exports.errorSuspended = errorSuspended;
exports.errorFeatureDisabled = errorFeatureDisabled;
exports.errorUnsupportedLocale = errorUnsupportedLocale;
/**
 * Cross-cutting errors: shared schemas, error specs, and factories.
 *
 * Provides the data schemas, the `sharedErrorSpecs` bundle attached to every
 * procedure (via `baseProcedure` in `base.ts`), and the throwing factories used
 * by server-side core code.
 *
 * These cover the codes every API can hit: the request has no session
 * (UNAUTHORIZED), the session is not admin (FORBIDDEN), the request metadata is
 * malformed (BAD_REQUEST), a referenced resource is missing (NOT_FOUND), the
 * targeted feature is switched off by server config (FEATURE_DISABLED), the
 * requested locale can't serve the call (UNSUPPORTED_LOCALE), the caller is
 * being throttled (RATE_LIMITED), or something unexpected blew up
 * (INTERNAL_ERROR). Per-procedure errors live next to the procedure that
 * throws them in `procedures/<name>.ts`.
 *
 * Defined errors flow to the client as typed errors and appear in the OpenAPI
 * spec; the server never reports them to Sentry (see `server/orpc/handler.ts`).
 * Only undefined errors are captured.
 *
 * English messages on the factories are load-bearing: clients on the legacy
 * transport read `error` as a string and display it to the user.
 */
const client_1 = require("@orpc/client");
const z = __importStar(require("zod"));
exports.UnauthorizedErrorDataSchema = z.object({ reason: z.string() });
exports.ForbiddenErrorDataSchema = z.object({ reason: z.string() });
exports.BadRequestErrorDataSchema = z.object({ field: z.string().optional(), reason: z.string() });
exports.NotFoundErrorDataSchema = z.object({ resource: z.string(), key: z.string() });
exports.InternalErrorDataSchema = z.object({ detail: z.string().optional() });
exports.SuspendedErrorDataSchema = z.object({ endDate: z.number().nullable() });
exports.FeatureDisabledErrorDataSchema = z.object({ feature: z.string() });
exports.UnsupportedLocaleErrorDataSchema = z.object({ locale: z.string(), reason: z.string() });
/**
 * Nothing in core throws RATE_LIMITED yet. It is reserved in the contract so
 * that a future limiter at any layer — application middleware or a partner's
 * infrastructure returning 429 through the same surface — is a compatible
 * addition rather than a breaking contract change.
 */
exports.RateLimitedErrorDataSchema = z.object({ retryAfterSeconds: z.number().optional() });
/**
 * Errors shared across every procedure. Attached on the base contract builder.
 */
exports.sharedErrorSpecs = {
    UNAUTHORIZED: { status: 401, data: exports.UnauthorizedErrorDataSchema },
    FORBIDDEN: { status: 403, data: exports.ForbiddenErrorDataSchema },
    BAD_REQUEST: { status: 400, data: exports.BadRequestErrorDataSchema },
    NOT_FOUND: { status: 404, data: exports.NotFoundErrorDataSchema },
    INTERNAL_ERROR: { status: 500, data: exports.InternalErrorDataSchema },
    SUSPENDED: { status: 403, data: exports.SuspendedErrorDataSchema },
    FEATURE_DISABLED: { status: 403, data: exports.FeatureDisabledErrorDataSchema },
    UNSUPPORTED_LOCALE: { status: 400, data: exports.UnsupportedLocaleErrorDataSchema },
    RATE_LIMITED: { status: 429, data: exports.RateLimitedErrorDataSchema },
};
function errorUnauthorized(reason) {
    return new client_1.ORPCError('UNAUTHORIZED', {
        status: 401,
        data: { reason },
        message: reason,
    });
}
function errorForbidden(reason) {
    return new client_1.ORPCError('FORBIDDEN', {
        status: 403,
        data: { reason },
        message: reason,
    });
}
function errorBadRequest(reason, field) {
    return new client_1.ORPCError('BAD_REQUEST', {
        status: 400,
        data: { reason, ...(field ? { field } : {}) },
        message: reason,
    });
}
/**
 * `resource` is the product's own name for the thing, as the contract names it
 * — not an internal structure key, collection name, or table name. It reaches
 * the user verbatim through the default message.
 */
function errorNotFound(resource, key, message) {
    return new client_1.ORPCError('NOT_FOUND', {
        status: 404,
        data: { resource, key },
        message: message ?? `${resource} not found: ${key}`,
    });
}
function errorSuspended(endDate) {
    return new client_1.ORPCError('SUSPENDED', {
        status: 403,
        data: { endDate },
        message: endDate ? `User is suspended until ${new Date(endDate).toISOString()}` : 'User is suspended',
    });
}
/**
 * The targeted feature is switched off by server config (e.g. an env flag), so
 * the procedure can't run. `feature` names the disabled capability so a client
 * can render a feature-specific explanation. Not a permission failure — the
 * caller may be a full admin; the whole feature is simply unavailable.
 */
function errorFeatureDisabled(feature) {
    return new client_1.ORPCError('FEATURE_DISABLED', {
        status: 403,
        data: { feature },
        message: `Feature is disabled: ${feature}`,
    });
}
/**
 * The `locale` the call named cannot serve it. Today that means `'*'` reached a
 * path needing one concrete language — a write names the language its text is
 * authored in, so "every locale" is not an answer it can use.
 */
function errorUnsupportedLocale(locale, reason) {
    return new client_1.ORPCError('UNSUPPORTED_LOCALE', {
        status: 400,
        data: { locale, reason },
        message: `Unsupported locale "${locale}": ${reason}`,
    });
}
//# sourceMappingURL=errors.js.map